import { useApolloClient, useLazyQuery, gql } from '@apollo/client';
import { RodRequest } from '@bechtel/types';
import { GET_ROD_REQUESTS_DETAILS_BY_IDS } from '@bechtel/client-gql';
import { forEach } from 'lodash';

export function useRodRequestCache() {
  const [getRodRequestByIds] = useLazyQuery<{ rodRequestsByIds: RodRequest[] }, { ids: string[] }>(
    GET_ROD_REQUESTS_DETAILS_BY_IDS,
    {
      fetchPolicy: 'network-only',
    }
  );
  const client = useApolloClient();

  const updateRodRequestCache = (rodRequestIds: RodRequest['id'][]) => {
    if (!rodRequestIds || rodRequestIds.length == 0) return;
    const cachedRodRequestIds: RodRequest['id'][] = [];

    forEach(rodRequestIds, (rodRequestId) => {
      const cachedRodRequest = client.readFragment({
        id: 'RodRequest:' + rodRequestId,
        fragment: gql`
          fragment rodRequest on RodRequest {
            id
          }
        `,
      });
      if (cachedRodRequest) cachedRodRequestIds.push(rodRequestId);
    });
    if (cachedRodRequestIds.length == 0) return;

    getRodRequestByIds({
      variables: {
        ids: rodRequestIds,
      },
    });
  };

  return { updateRodRequestCache };
}
